export const volumes = [
  {
    number: '01',
    title: 'Método y planificación del instructor',
    body: 'Organizá objetivos, clases, demostraciones, prácticas y tiempos para enseñar con una estructura clara.',
    flow: ['Planificar', 'Explicar', 'Demostrar'],
  },
  {
    number: '02',
    title: 'Detailing exterior',
    body: 'Enseñá inspección, lavado, descontaminación, secado, terminaciones y protección mediante procesos organizados.',
    flow: ['Inspeccionar', 'Limpiar', 'Proteger'],
  },
  {
    number: '03',
    title: 'Detailing interior',
    body: 'Trabajá plásticos, textiles, alfombras, cuero, cristales y superficies delicadas con criterio y métodos progresivos.',
    flow: ['Identificar', 'Limpiar', 'Tratar'],
  },
  {
    number: '04',
    title: 'Corrección de pintura, pulido y protección',
    body: 'Enseñá diagnóstico de pintura, test spot, pulido, refinado y protección desarrollando criterio técnico.',
    flow: ['Diagnosticar', 'Corregir', 'Proteger'],
  },
  {
    number: '05',
    title: 'Taller práctico con autos reales',
    body: 'Organizá demostraciones, estaciones de trabajo, prácticas guiadas y ejercicios para que tus alumnos aprendan haciendo.',
    flow: ['Demostrar', 'Practicar', 'Corregir'],
  },
  {
    number: '06',
    title: 'Evaluación, gestión y profesionalización',
    body: 'Evaluá alumnos, registrá avances y organizá materiales, cupos, costos y seguimiento de tus capacitaciones.',
    flow: ['Evaluar', 'Registrar', 'Mejorar'],
  },
];
